import { render } from "./TheBankAccountList.vue?vue&type=template&id=4cf77ecc&scoped=true&ts=true"
import script from "./TheBankAccountList.vue?vue&type=script&lang=ts"
export * from "./TheBankAccountList.vue?vue&type=script&lang=ts"

import "./TheBankAccountList.vue?vue&type=style&index=0&id=4cf77ecc&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4cf77ecc"]])

export default __exports__